const defaultState = () => {
	return {
		roles: {
			count: 0,
			results: [],
		},
		role: {
			id: null,
			role: null,
			priority: 0,
		},
	};
};

const state = {
	roles: defaultState().roles,
	role: defaultState().role,
};

const getters = {
	roles: (state) => {
		return state.roles;
	},
	role: (state) => {
		return state.role;
	},
};

const actions = {};

const mutations = {
	GET_ROLES: (state, payload) => {
		if (payload) {
			state.roles.count += payload.results
				? payload.results.length
				: payload.data.length;
			state.roles.results = state.roles.results.concat(
				payload.results || payload.data
			);
		} else {
			state.roles = defaultState().roles;
		}
	},
	CREATE_ROLE: (state, payload) => {
		state.roles.count += 1;
		state.roles.results.push(payload.data);
	},
	READ_ROLE: (state, payload) => {
		if (payload) {
			state.role = payload.data;
		} else {
			state.role = defaultState().role;
		}
	},
	UPDATE_ROLE: (state, payload) => {
		const index = state.roles.results.findIndex(
			(item) => item.id == payload.data.id
		);

		if (0 <= index) state.roles.results.splice(index, 1, payload.data);
	},
	DELETE_ROLE: (state, payload) => {
		const index = state.roles.results.findIndex(
			(item) => item.id == payload.data.id
		);

		if (0 <= index) {
			state.roles.count -= 1;
			state.roles.results.splice(index, 1);
		}
	},
};

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations,
};
